// ReferralStrip.jsx — horizontal row of partner/affiliate links.
// Only renders partners whose href is not '#' (configured in referrals.js).
import { ExternalLink } from 'lucide-react';
import { PARTNERS } from '../../config/referrals';

/**
 * @param {'strip'|'cards'} variant  'strip' = compact pill row, 'cards' = taller cards with tagline.
 * @param {string} className  Extra Tailwind classes for the outer wrapper.
 */
export default function ReferralStrip({ variant = 'strip', className = '' }) {
  const active = PARTNERS.filter((p) => p.href !== '#');
  if (active.length === 0) return null;

  if (variant === 'cards') {
    return (
      <div className={`rounded-2xl border border-gray-700/40 bg-gray-800/30 p-5 ${className}`}>
        <p className="text-xs font-semibold text-gray-500 uppercase tracking-widest mb-4 text-center">
          Play on your favourite platform
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
          {active.map((p) => (
            <a
              key={p.id}
              href={p.href}
              target="_blank"
              rel="noopener noreferrer sponsored"
              className={`${p.bg} ${p.text} rounded-xl px-4 py-3 flex flex-col items-center gap-1 hover:opacity-90 transition-opacity`}
            >
              <span className="font-bold text-sm">{p.label}</span>
              <span className="text-xs opacity-80">{p.tagline}</span>
              <ExternalLink className="h-3 w-3 opacity-60 mt-0.5" />
            </a>
          ))}
        </div>
        <p className="text-center text-gray-700 text-xs mt-3">
          Sponsored · Gambling involves risk. 18+ only.
        </p>
      </div>
    );
  }

  // default: strip
  return (
    <div className={`flex items-center gap-2 flex-wrap justify-center ${className}`}>
      <span className="text-gray-600 text-xs font-semibold uppercase tracking-wide">Play on:</span>
      {active.map((p) => (
        <a
          key={p.id}
          href={p.href}
          target="_blank"
          rel="noopener noreferrer sponsored"
          className={`${p.bg} ${p.text} rounded-full px-3 py-1 text-xs font-semibold flex items-center gap-1 hover:opacity-90 transition-opacity`}
        >
          {p.label}
          <ExternalLink className="h-2.5 w-2.5 opacity-70" />
        </a>
      ))}
    </div>
  );
}
